<div class="globalNav">
    <app-nav></app-nav>
</div>
<div class="globalContent">
    <router-outlet></router-outlet>
</div>
<div class="globalFooter">
    <app-footer></app-footer>
</div>
